import {getTestProps} from '@benchling/js-test-utils';
import classNames from 'classnames';
import React, {ReactNode} from 'react';

export interface BufferOptionsItemProps {
  className?: string;
  children?: ReactNode;
}

export default function BufferOptionsItem(props: BufferOptionsItemProps): JSX.Element {
  return (
    <div
      className={classNames('buffer-options-item', props.className)}
      {...getTestProps({
        component: 'BufferOptionsItem',
        element: 'root',
      })}
    >
      {props.children}
    </div>
  );
}
